// The item body format (spec §3.2): blank line = new paragraph, "- " lines = bullets (one level),
// **bold**, [text](https://link). Parsed into plain data — renderers never inject HTML, so any
// HTML a user types shows as literal text, and only http(s) links become links.
const INLINE = /\*\*(.+?)\*\*|\[([^\]]+)\]\(([^)\s]+)\)/g;
const BULLET = /^\s*[-*]\s+(.*)$/;

export function parseInline(text) {
  const out = [];
  const src = String(text ?? "");
  let last = 0;
  const push = (v) => { if (!v) return; const prev = out[out.length - 1]; if (prev && prev.t === "text") prev.v += v; else out.push({ t: "text", v }); };
  for (const m of src.matchAll(INLINE)) {
    push(src.slice(last, m.index));
    if (m[1] !== undefined) out.push({ t: "b", v: m[1] });
    else if (/^https?:\/\//i.test(m[3])) out.push({ t: "a", v: m[2], href: m[3] });
    else push(m[0]);
    last = m.index + m[0].length;
  }
  push(src.slice(last));
  return out;
}

// Rewrites every link parseBody/parseInline would see — scanning line by line with the same
// INLINE regex, so bold runs consume exactly what they do when rendering — via fn(label, href,
// match). Everything else is returned untouched. publicView uses it to unwrap SharePoint links
// structurally: whatever MarkdownLite would turn into a link is what gets checked.
export function mapInlineLinks(text, fn) {
  return String(text ?? "").split(/(\r?\n)/).map((line) =>
    line.replace(INLINE, (m, bold, label, href) => (bold !== undefined ? m : fn(label, href, m)))).join("");
}

export function parseBody(src) {
  const blocks = [];
  let cur = null;
  for (const line of String(src ?? "").split(/\r?\n/)) {
    if (!line.trim()) { cur = null; continue; }
    const b = line.match(BULLET);
    if (b) {
      if (!cur || cur.type !== "ul") { cur = { type: "ul", items: [] }; blocks.push(cur); }
      cur.items.push(parseInline(b[1]));
    } else {
      if (!cur || cur.type !== "p") { cur = { type: "p", lines: [] }; blocks.push(cur); }
      cur.lines.push(parseInline(line));
    }
  }
  return blocks;
}
